import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Switch } from "react-router-dom";

// Import Routes
import { publicRoutes } from "./routes/";
import AppRoute from "./routes/route";

// layouts
import NonAuthLayout from "./components/Layout/NonAuthLayout";

import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-092966}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Morpara}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Morpara}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Morpara}_need_to_be_licensed___{Morpara}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{12_September_2026}____[v3]_[01]_MTc4OTE2NzYwMDAwMA==3a52187bb05d1eb4921eaad9adfb3612");

// Import scss
import "./assets/scss/theme.scss";
import ProtectedRoutes from "routes/protectedRoutes";

import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    // window.addEventListener("beforeunload", this.keepOnPage);
    // window.removeEventListener("load", this.keepOnPage);
  }

  keepOnPage(e) {
    let message =
      "Warning!\n\nNavigating away from this page will delete your text if you haven't already saved it.";
    e.returnValue = message;
    return message;
  }

  render() { 
    return (
      <React.Fragment>
        <Router>
          <Switch>
            {publicRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={NonAuthLayout}
                component={route.component}
                key={route.path}
                page={route.page ?? ""}
                isAuthProtected={false}
              />
            ))}
            <ProtectedRoutes isAuthProtected={true} />
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

App.propTypes = {
  layout: PropTypes.object,
};

export default connect(mapStateToProps, null)(App);